import React from 'react';


export function Patientinfo() { 
    return (
      <>  
        
        <h1>billing</h1>
      </>
    );
   };